import { FormValues } from "@/schema/console/assessments/create/FormValues";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";


interface SubCategoryProps {
  categoryIndex: number;
}

function SubCategoryCount({ categoryIndex }: SubCategoryProps) {
  const { t } = useTranslation();
  const { control } = useFormContext<FormValues>();
  const subcategories = useWatch({
    control,
    name: `categories.${categoryIndex}.subcategories`,
  });
  const subCategoryCount = subcategories.length;

  return (
    <div className="font-medium text-cool-gray-600">
      {subCategoryCount > 1
        ? `${subCategoryCount} ${t("sub-categories")}`
        : `${subCategoryCount} ${t("sub-category")}`}
    </div>
  );
}

export default SubCategoryCount;
